/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessPremisesStatusEnumDTO } from './business-premises-status-enum-dto';
import { AddressDataDTO } from './address-data-dto';
import { EntityErrorsInvalidEntitiesDTO } from './entity-errors-invalid-entities-dto';
import { StatusLogDTO } from './status-log-dto';


/**
 * BusinessPremises with status log information.
 */
export interface BusinessPremisesWithStatusLogDTO { 
    /**
     * Represents the internal id of the associated organization
     */
    parentOrgId: string;
    /**
     * Represents the internal id of business premises
     */
    id: string;
    /**
     * Represents an external id of business premises
     */
    businessPremisesIdentifier: string;
    /**
     * name or description for the business premises
     */
    name?: string;
    /**
     * Optional description of the entity
     */
    detailedDescription?: string;
    status?: BusinessPremisesStatusEnumDTO;
    addressData?: AddressDataDTO;
    /**
     * Tax office remark. AO §146a bemerkungen
     */
    taxOfficeRemark?: string;
    /**
     * The datetime field that will be set when business premises is set to disabled
     */
    deactivationDate?: string;
    errors?: EntityErrorsInvalidEntitiesDTO;
    /**
     * The date the preview was generated for the latest successfully submitted registration protocol
     */
    lastSuccessRegistrationProtocolPreviewDate?: string;
    /**
     * Creation date
     */
    createdDate?: string;
    /**
     * Date of last change
     */
    lastModifiedDate?: string;
    /**
     * Created by
     */
    createdBy?: string;
    /**
     * Last modified by
     */
    lastModifiedBy?: string;
    statusLogs?: Array<StatusLogDTO>;
}

export class ClsBusinessPremisesWithStatusLogDTO { 
    /**
     * Represents the internal id of the associated organization
     */
    parentOrgId: string = undefined;
    /**
     * Represents the internal id of business premises
     */
    id: string = undefined;
    /**
     * Represents an external id of business premises
     */
    businessPremisesIdentifier: string = undefined;
    /**
     * name or description for the business premises
     */
    name?: string = undefined;
    /**
     * Optional description of the entity
     */
    detailedDescription?: string = undefined;
    status?: BusinessPremisesStatusEnumDTO = undefined;
    addressData?: AddressDataDTO = undefined;
    /**
     * Tax office remark. AO §146a bemerkungen
     */
    taxOfficeRemark?: string = undefined;
    /**
     * The datetime field that will be set when business premises is set to disabled
     */
    deactivationDate?: string = undefined;
    errors?: EntityErrorsInvalidEntitiesDTO = undefined;
    /**
     * The date the preview was generated for the latest successfully submitted registration protocol
     */
    lastSuccessRegistrationProtocolPreviewDate?: string = undefined;
    /**
     * Creation date
     */
    createdDate?: string = undefined;
    /**
     * Date of last change
     */
    lastModifiedDate?: string = undefined;
    /**
     * Created by
     */
    createdBy?: string = undefined;
    /**
     * Last modified by
     */
    lastModifiedBy?: string = undefined;
    statusLogs?: Array<StatusLogDTO> = undefined;
}



